<div class="container mt-4 p-4 total-intake">
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Total Caloric and Macronutrient Intake</h5>
      <p class="card-text">This interactive chart is designed to dynamically reflect your daily consumption of carbohydrates, fats, proteins, and alcohol. As you
        input the types and quantities of foods you consume throughout the day, the progress bars will automatically update. Each bar represents the proportion of
        each macronutrient consumed in relation to your daily goals. This real-time tracking allows you to monitor and adjust your intake, ensuring a balanced and
        healthy diet.</p>
    </div>

    <div class="container">
      <div class="row g-0">
        <div class="col-1">Carbs:</div>
        <div class="col-11">
          <div class="progress" role="progressbar" aria-label="Success example" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-carbs" [style.width.%]="this.percentOfCarbGoal" title="carbohydrates">
              {{this.percentOfCarbGoal}}%</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-1">Fat:</div>
        <div class="col-11">
          <div class="progress" role="progressbar" aria-label="Info example" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-fat text-dark" [style.width.%]="this.percentOfFatGoal" title="Fat">
              {{this.percentOfFatGoal}}%
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-1">Protein:</div>
        <div class="col-11">
          <div class="progress" role="progressbar" aria-label="Warning example" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-protein" [style.width.%]="this.percentOfProteinGoal" title="Protein">
              {{this.percentOfProteinGoal}}%
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-1">Alcohol:</div>
        <div class="col-11">
          <div class="progress" role="progressbar" aria-label="Danger example" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-alcohol" [style.width.%]="this.percentOfAlcoholGoal" title="Alcohol">
              {{this.percentOfAlcoholGoal}}%</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-1">Calories:</div>
        <div class="col-11">
          <div class="progress" role="progressbar" aria-label="Danger example" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-calories" [style.width.%]="this.percentOfCaloriesGoal" title="Calories">
              {{this.percentOfCaloriesGoal}}%</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
